export default {
  host: "http://localhost:8001/api/",
};
